import api from "../api";

const controller = 'crfContratos';

export interface ResumoCrfContratado {
    // codigoPacote: string;
    // numero: string;
    nome: string;
    codigoContaContabil: string;
    codigoAgrupador: string;
    status: string;
    valorTotalFormatado: string;
    valorTotalTipoOverHeadFormatado: string;
    contratoCompraValorTotalFormatado: string;
    contaContabilCcId: string;
    index: number;
}

export interface CrfContratadoRequisicaoCompraServico {
    narrativa: string;
    contratadoCompraNumero: number;
    contratadoCompraSeq: number;
    requisicaoCompraValorTotal: string;
    requisicaoCompraValorTotalFormatado: string;
    valorParaDistribuidoFormatado: string;
    valorDistribuidoFormatado: string;
    distribuidoTotalFormatado: string;
    ordemInvestimentoId: string;
    principalFormatado: string;
    contratadoCompraOc: string;
    pedidoPcm: number;
    pedidoCtPcs: number;
    index: number;
}

export interface CrfContratadoRequisicaoCompraMaterial {
    narrativa: string;
    contratadoCompraNumero: number;
    contratadoCompraSeq: number;
    requisicaoCompraValorTotal: string;
    requisicaoCompraValorTotalFormatado: string;
    valorParaDistribuidoFormatado: string;
    valorDistribuidoFormatado: string;
    distribuidoTotalFormatado: string;
    ordemInvestimentoId: string;
    principalFormatado: string;
    contratadoCompraOc: string;
    pedidoPcm: number;
    index: number;
}


export interface CrfRequisitadoAno {
    pcmId: string;
    requisicaoCompraSeqId: string;
    ordemInvestimentoId: string;
    ordemInvestimentoRequisicaoCompraSeqId: string;
    moduloEconomicoContratadoId: string;
    ordemCompraId: string;

    ordemInvestimentoRequisicaoCompraSeqPrincial: boolean;

    pacoteProjeto: string;
    pacotePctOi: string;

    requisicaoCompraNumero: number;
    requisicaoCompraSeq: string;
    requisicaoCompraPrecoUnitarioFormatado: string;
    requisicaoCompraPrecoUnitario: number;
    requisicaoCompraQuantidadeTotal: string;
    requisicaoCompraValorTotal: number;
    requisicaoCompraValorTotalFormatado: string;
    requisicaoCompraOc: string;

    pedidoPcm: string;
    pedidoCtPcs: string;
    pedidoCtPreUnitarioFormatado: string;
    valorUnitarioPedido: number;

    valorFormatado: string;
    quantidadeFormatado: string;
    numero: string;
}

export interface CrfContratadoOverHeadAnual {
    resultDataTabel: CrfRequisitadoAno[];
    anos: number[];
}

export const getAllResumoCrfContratadoProjeto = (projetoId: any) =>
    api.get<ResumoCrfContratado[]>(`${controller}/projeto/${projetoId}/resumo`);

export const getAllCrfContratadoMaterialByContaContabilCc = (contaContabilCcId: any) =>
    api.get<CrfContratadoRequisicaoCompraMaterial[]>(`${controller}/contaContabilCc/${contaContabilCcId}/material`);

export const getAllCrfContratadoServicoByContaContabilCc = (contaContabilCcId: any) =>
    api.get<CrfContratadoRequisicaoCompraServico[]>(`${controller}/contaContabilCc/${contaContabilCcId}/servico`);

export const getAllCrfContratadoTipoOverHeadByContaContabilCc = (contaContabilCcId: any) =>
    api.get<CrfContratadoOverHeadAnual>(`${controller}/contaContabilCc/${contaContabilCcId}/tipoOverHead`);

export interface UpdateCrfContratadoOverHead {
    crfContaContabilCcId: string;
    valor: number;
}

export const CreateUpdateCrfContratadoTipoOverHeadByContaContabilCc = (contaContabilCcId: any, values: UpdateCrfContratadoOverHead) =>
    api.post<CrfContratadoOverHeadAnual>(`${controller}/contaContabilCc/${contaContabilCcId}/tipoOverHead`, values);